import React from 'react';
import { Card, CardBody, Progress} from 'reactstrap';

function Upload_progressbar({progress , status}) {
  return (
    <>
        <div className='progress_bar'>
            <Card className="overflow-hidden shadow-none">
            <CardBody>
                <div className="d-flex">
                    <div className="flex-grow-1">
                        <h6 className="mb-0"><b className="text-secondary">{progress}%</b>{" "}{status.replaceAll("_", " ")}</h6>
                    </div>
                    {/* <div className="flex-shrink-0">
                        <h6 className="mb-0">1 min left</h6>
                    </div> */}
                </div>
            </CardBody>
            <div >
                <Progress value={parseInt(progress)} color="secondary" className="bg-secondary-subtle rounded-0" />
            </div>
        </Card>
        </div>
    </>
  )
}

export default Upload_progressbar